import { revid, version } from './version';
import { DigiResEnvironment } from './EnvironmentTypes';

export const environment: DigiResEnvironment = {
  production: false,
  name: 'debug',
  title: 'DigiRES debug',
  showMap: true,

  version: version,
  revid: revid,
  apiURL: '/api/*',
  udpURL: 'https://udp-debug.ext.dg.renewables-apps.com/',
};
